/** @format */

import React from 'react'

import { Form, Button, Card, Select, Input } from 'antd'

import { serviceInjectToken } from './services'

import './style.css'

export default function TokenPtoPagoV2() { //TODO REFACTOR
	return (
		<Card title='Reenviar token de punto pago'>
			<div className='ph-resend-token-container'>
				<div className='ph-resend-token-main-container'>
					<h1 className='ph-resend-token-title'>Ingrese token</h1>
					<Form
						name='basic'
						initialValues={{ module: 'pharol' }}
						onFinish={(item) => serviceInjectToken(item)}
						className={'ph-resend-token-form-container'}>
						<Form.Item label='Módulo' name='module' required={[{ required: true }]}>
							<Select>
								<Select.Option value='pharol'>Marketplace</Select.Option>
								{/* <Select.Option value='jvf'>JVF</Select.Option> */}
							</Select>
						</Form.Item>
						<Form.Item label='Token' name='token' rules={[{ required: true }]}>
							<Input />
						</Form.Item>
						<Form.Item>
							<div className='ph-resend-token-button-container'>
								<Button htmlType='submit' className='ph-resend-token-button'>
									Reenviar
								</Button>
							</div>
						</Form.Item>
					</Form>
				</div>
			</div>
		</Card>
	)
}
